// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomeBlock-module--wrapper--3fIGW","title":"HomeBlock-module--title--3MiUG","btn":"HomeBlock-module--btn--2sUCr"};